import { Component, ɵConsole } from '@angular/core';
import { GridBaseCase } from '../grid.base.case';
import { HttpCustomerService } from '../../../../service/httpcustomer.service';
import { WebParameterContext } from '../../../../model/common';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageclientService } from '../../../../service/messageclient.service';
import { CommonService } from '../../../../service/common.service';
import { HandleWebParameterContextBeforeDBRequest, HandleServerContextAfterDBRequest, ContextBeforeChangeValue } from '../../../../bizlogic/servicesbll';
import { BaseCase } from '../../../basecase';
declare var app;
@Component({
  selector: 'app-mz-grid-list-form',
  templateUrl: './mz-grid-list-form.component.html',
  styleUrls: ['./mz-grid-list-form.component.scss']
})
export class MzGridListFormComponent extends GridBaseCase {
  // arrayData: Array<any> = new Array<any>();
  type: any = null;
  isPlacingOrder: boolean = false;//已下单是否显示
  // orderList: Array<any> = new Array<any>();//已下单列表
  totalCount = 0;//已下单总数量
  totalMoney = 0;//已下单总金额
  constructor(
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private router: Router,
    private msg: MessageclientService,
    public baseService: BaseCase,
    private common: CommonService
  ) {
    super();
  }
  newArrayFN(arraylist: Array<any>) {
    const that = this;
    let groupName: string = null;
    let title: string = null;
    const group = that.element.selectItemList.selectItem.find(ut => ut.bindingField == "groupName");
    if (group) {
      groupName = group.field;
    }
    const gtitle = that.element.selectItemList.selectItem.find(ut => ut.bindingField == "title");
    if (gtitle) {
      title = gtitle.field;
    }
    arraylist.forEach((item, index) => {
      let _obj: any = { GroupName: null, items: [] };

      let result = that.baseService.arrayData.find(t => t.GroupName.toLowerCase() === item[groupName].toLowerCase());
      // let result = false;
      // that.baseService.arrayData.forEach(t=>{
      //   if(t.GroupName.toLowerCase() === item[groupName].toLowerCase()){
      //     result = true;
      //   }
      // })
      
      if (result) {
        that.baseService.arrayData.forEach((ut, indexof) => {
          if (item[groupName]) {
            if (ut.GroupName.toLowerCase() === item[groupName].toLowerCase()) {
              delete item.GroupName;
              that.baseService.arrayData[indexof].items.push(item);
            }
          }
        });
      } else {
        _obj.GroupName = item[groupName];
        delete item[groupName];
        _obj.items.push(item);
        that.baseService.arrayData.push(_obj);
      }
    });
  }
  /**
   * 下拉刷新数据
   * @param event
   */
  doRefresh(event) {
    this.LoadData();
    event.target.complete();
  }
  LoadData() {
    const that = this;
    that.loading = false;
    that.apiObj['status'] = false;
    that.apiObj['msg'] = '';
    const pageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    const types = that.activaRouter.snapshot.paramMap.get('type');
    const id = that.activaRouter.snapshot.paramMap.get('id');
    that.type = types;
    let body: WebParameterContext = new WebParameterContext();
    if (that.element.selectItemList.gridViewConfigName) {
      body.ConfigName = that.element.selectItemList.gridViewConfigName;
    } else if (that.ConfigName) {
      body.ConfigName = that.ConfigName;
    }
    body.OpType = "query";
    body.ConfigType = "view";
    // if (types) {
    //   body.ConfigName = "TBJingZhiYouJiXML2";
    //   body.OpType = "query";
    //   body.ConfigType = "view";
    // }
    body.Client.PageName = pageName;
    // if (that.platform.is("android")) {
    //   body.Client.ClientType = 0;
    // } else if (that.platform.is("ios")) {
    //   body.Client.ClientType = 1;
    // }
    if(id && types=="edite"){
      body.OpType = "edite";
      body.RequestBody = JSON.stringify({"a_ID":id});
    }
    body = HandleWebParameterContextBeforeDBRequest(body);
    if (!body.ResponseMessage.Success) {
      that.msg.Alert(body.ResponseMessage.ErrorMessage);
      return;
    }
    that.http.post(app.DEFAULTURL, body).then(data => {
      data = HandleServerContextAfterDBRequest(body, data);
      that.baseService.arrayData = new Array<any>();
      setTimeout(function () {
        that.apiObj['status'] = data.ResponseMessage.Success;
        that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
        that.loading = true;
      });
      if (data.ResponseMessage.Success) {
        that.newArrayFN(data.Status.Datas);
        that.baseService.arrayData.forEach(function (item, i) {
          item['isOpen'] = false;
          if (i == 0) {
            item['isOpen'] = true;
          }
          if(body.OpType == "edite"){
            that.onInput(item);
          }
        });
      } else {
        console.log(data.ResponseMessage.ErrorMessage);
      }

    }).catch(error => {
      console.log(error);
      that.apiObj['status'] = false;
      that.apiObj['msg'] = "失败了";
      // that.apiObj['msg'] = "error.error.ResponseMessage.ErrorMessage";
      that.loading = true;
    });
  }
  selectItem(index) {
    this.baseService.arrayData.forEach(function (item, i) {
      if (index == i) {
        item['isOpen'] = !item['isOpen'];
      } else {
        item['isOpen'] = false;
      }
    });
  }
  onInput(item) {
    const ConfigName = this.activaRouter.snapshot.paramMap.get('ConfigName');
    item['isPlacingOrder'] = this.isPlacingOrder;
    item = ContextBeforeChangeValue(item, ConfigName);
    this.isPlacingOrder = item['isPlacingOrder'];
    delete item['isPlacingOrder'];
    // if(ConfigName == "ListForm"){
    //   if (parseInt(item.a_xiadanliang) > parseInt(item.a_kucun)) {
    //     item.a_xiadanliang = parseInt(item.a_kucun);
    //   }
    //   item.a_zongjia = item.a_danjia * item.a_xiadanliang;
    // }else if(ConfigName == "Supply"){

    // }else if(ConfigName == "DataReport"){
    //   if(item.a_ZiRanXiaoLiang > 0){
    //     item.a_XiaoLiangHeJi = item.a_ZiRanXiaoLiang + (item.a_XiaoLiang?item.a_XiaoLiang: item.a_XiaoLiang = 0);
    //   }
    // }

    this.checkOrder(item);

  }
  eventClick(data) {
    const that = this;
    const requestBody = this.checkData(data);
    const pageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    const types = that.activaRouter.snapshot.paramMap.get('type');
    const id = that.activaRouter.snapshot.paramMap.get('id');
    let body: WebParameterContext = new WebParameterContext();
    if (that.element.selectItemList.gridViewConfigName) {
      body.ConfigName = that.element.selectItemList.gridViewConfigName;
    } else if (that.ConfigName) {
      body.ConfigName = that.ConfigName;
    }
    body.OpType = types||"add";
    body.ConfigType = "form";
    body.ID = id;
    body.Client.PageName = pageName;
    body.RequestBody = JSON.stringify(requestBody);
    body.SpecialParameter = that.baseService.order;

    body = HandleWebParameterContextBeforeDBRequest(body);
    if (!body.ResponseMessage.Success) {
      that.msg.Alert(body.ResponseMessage.ErrorMessage);
      return;
    }
    that.http.post(app.DEFAULTURL, body).then(data => {
      data = HandleServerContextAfterDBRequest(body, data);
      if (data.ResponseMessage.Success) {
        if(!data.Status.ignore){
          that.msg.Confirm("是否返回首页").then(data => {
            if (data) {
               that.baseService.arrayData = new Array<any>();
                that.baseService.order = {
                  totalCount: 0,
                  totalMoney: 0,
                  Data: new Array<any>()
                }
              that.common.Go("/tabs/" + that.common.getHonmeUrl().Url);
            }
          })
        }else{
          that.msg.Confirm("下单成功","返回首页","查看详情").then((ft)=>{
            if(ft){
            //  that.router.navigate(["/tabs/contact/OrderList"]);
             that.common.Go("/tabs/contact/OrderList");
            }else{
             that.common.Go("/tabs/" + that.common.getHonmeUrl().Url);
            }
          })

        }
      } else {
        that.msg.Alert(data.ResponseMessage.ErrorMessage);
      }

    }).catch(error => {
      console.log(error);
    })
  }

  /**
   * 
   * @param data 
   */
  checkData(data: Array<any>) {
    const that = this;
    let groupName: string = null;
    const group = that.element.selectItemList.selectItem.find(ut => ut.bindingField == "groupName");
    if (group) {
      groupName = group.field;
    }
    let resultArray: Array<any> = [];
    data.forEach((items, index) => {
      items.items.forEach((ts, indexs) => {
        if (ts.a_xiadanliang > 0 || ts.a_BuHuoLiang > 0 || ts.a_ZiRanXiaoLiang > 0) {
          ts[groupName] = items.GroupName;
          resultArray.push(ts);
        }
      });
    });
    return resultArray;
  }

  /**
   * 已下单列表
   * @param data 
   */
  checkOrder(data) {
    let that = this;
    let flag = false;
    let field = null;
    let orderIndex = 0;
    that.baseService.order.Data.forEach((item, i) => {
      if (item.a_title == data.a_title) {
        flag = true;
        orderIndex = i;
      }
    });
    // console.log(that.baseService.order.Data,flag,'flag',data,'data');
    that.element.selectItemList.selectItem.forEach(item => {
      if (item.elementType == 'Text') {
        field = item.field;
      }
    })
    if (flag && data[field] && data[field] > 0) {
      that.baseService.order.Data[orderIndex] = data;
    } else if (flag && (!data[field] || data[field] == 0)) {
      that.baseService.order.Data.splice(orderIndex, 1);
    } else if (!flag && data[field] && data[field] > 0) {
      that.baseService.order.Data.push(data);
    }
    that.baseService.order.totalCount = 0;
    that.baseService.order.totalMoney = 0;
    that.baseService.order.Data.forEach((item, i) => {
      that.baseService.order.totalCount += item.a_xiadanliang;
      that.baseService.order.totalMoney += item.a_zongjia;
    })
  }

  /**
   * 编辑事件
   */
  editData(){

  }

}
